// Permission Flags
export const canViewUsers = "canViewUsers";
export const canEditUsers = "canEditUsers";
export const canViewMyProfile = "canViewMyProfile";
export const canChangeCustomers = "canChangeCustomers";
export const canViewCustomers = "canViewCustomers";
export const canEditCustomers = "canEditCustomers";
export const canViewAppConfig = "canViewAppConfig";
export const canEditAppConfig = "canEditAppConfig";
export const canDeleteAppConfig = "canDeleteAppConfig";
export const canEditSSO = "canEditSSO";
export const canDeleteSSO = "canDeleteSSO";
export const canViewSSO = "canViewSSO";
export const canViewRole = "canViewRole";
export const canViewPolicy = "canViewPolicy";
export const canEditRole = "canEditRole";
export const canAssignRole = "canAssignRole";
export const canAssignApplications = "canAssignApplications";
export const canManageLocations = "canManageLocations";
export const canManageOrgHierarchies = "canManageOrgHierarchies";
export const canCreateActionItem = "canCreateActionItem";
export const canViewLocationsMenu = "canViewLocationsMenu";
export const canViewHierarchiesMenu = "canViewHierarchiesMenu";
export const canManageUserPreferences = "canManageUserPreferences";
export const canEditPersons = "canEditPersons";
export const canViewPersons = "canViewPersons";
export const canViewSensitiveData = "canViewSensitiveData";
export const canEditSensitiveData = "canEditSensitiveData";
export const canViewEhsConfig = "canViewEhsConfig";
export const canManageEhsRoles = "canManageEhsRoles";
export const canViewAdminMenu = "canViewAdminMenu";
export const canViewContractingCompanies = "canViewContractingCompanies";
export const canEditContractingCompanies = "canEditContractingCompanies";
export const canExploreReportingData = "canExploreReportingData";

// Returns true if the permission key is true on the user's PermissionsFlagObject
export const IsAllowed = (
  allowedPermissionKeys: string[],
  usersPermissions: PermissionsFlagObjectType | undefined,
  showIfAnyPermission: boolean = false
): boolean => {
  if (allowedPermissionKeys.length > 0) {
    const hasPermission = allowedPermissionKeys.map(
      (key: string) => usersPermissions && usersPermissions[key] === true
    );

    return showIfAnyPermission
      ? hasPermission.some((permission) => permission === true)
      : hasPermission.every((permission) => permission === true);
  }

  return true;
};

export type PermissionsFlagObjectType = {
  canViewAdminMenu: boolean;
  canViewEhsConfig: boolean;
  canViewUsers: boolean;
  canEditUsers: boolean;
  canViewMyProfile: boolean;
  canViewCustomers: boolean;
  canChangeCustomers: boolean;
  canEditCustomers: boolean;
  canViewAppConfig: boolean;
  canEditAppConfig: boolean;
  canDeleteAppConfig: boolean;
  canEditSSO: boolean;
  canDeleteSSO: boolean;
  canViewSSO: boolean;
  canViewRole: boolean;
  canViewPolicy: boolean;
  canEditRole: boolean;
  canAssignRole: boolean;
  canManageLocations: boolean;
  canManageOrgHierarchies: boolean;
  canAssignApplications: boolean;
  canCreateActionItem: boolean;
  canViewLocationsMenu: boolean;
  canViewHierarchiesMenu: boolean;
  canManageUserPreferences: boolean;
  canEditPersons: boolean;
  canViewPersons: boolean;
  canViewSensitiveData: boolean;
  canEditSensitiveData: boolean;
  canManageEhsRoles: boolean;
  canExploreReportingData: boolean;
  [key: string]: boolean;
};
